import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount } from 'react-use'

import { createDateObject } from 'packages/utils/dateHelpers'
import { useAsyncFnWithReset } from 'packages/utils/hooks'

import { fetchCrossCoverages } from 'app/fieldapp/store/crossCoverage/actions/fetchCrossCoverages'
import { getCrossCoverages } from 'app/fieldapp/store/crossCoverage/selectors/getCrossCoverages'

import { UpcomingCoverageEvents } from './UpcomingCoverageEvents'

export type UpcomingCoverageEventsProps = {}

export const UpcomingCoverageEventsContainer: React.FC<UpcomingCoverageEventsProps> =
  React.memo(() => {
    const dispatch = useDispatch()
    const coverageEvents = useSelector(getCrossCoverages)

    const [fetchCrossCoveragesState, fetchCrossCoveragesFn] =
      useAsyncFnWithReset(async () => {
        return dispatch(
          fetchCrossCoverages({ startDateGte: createDateObject() }),
        )
      }, [dispatch])

    useMount(() => {
      fetchCrossCoveragesFn()
    })

    return (
      <UpcomingCoverageEvents
        coverageEvents={coverageEvents}
        isError={Boolean(fetchCrossCoveragesState.error)}
        isLoading={fetchCrossCoveragesState.loading}
      />
    )
  })
